module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-music.svg?206505fe92adde49143e86693c5a6942";